import { isArray } from 'util';
import { PlanFile } from '../plan-file';

export class PlanFileBuilder {
  static fromJson(json) {
    return (json)
      ? new PlanFile(
        json.fileName,
        json.fileUrl
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(PlanFileBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/plan-file.builder.ts